import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_QUICK_SHOP_SUGGESTIONS = apiPromiseTypes(
  'basket-builder-experience-suggestions',
  'get',
);

export const GET_ESTIMATED_PRICE = apiPromiseTypes('pricing2-priced-products', 'post');
